import $axios from '@/core/api-config'
import { store } from '@/store'

class DiscussionsService {
  getAll ({ bookIds }) {
    const booksQuery = bookIds.join(',')
    return $axios.get(`/api/discussions?books=${booksQuery}`)
  }

  getById ({ id, bookId }) {
    return $axios.get(`/api/discussions/${bookId}/${id}`)
  }

  getDraft ({ bookIds }) {
    const booksQuery = bookIds.join(',')
    return $axios.get(`/api/discussions/draft?books=${booksQuery}`)
  }

  create ({ title, content, bookId }) {
    return $axios.post(`/api/discussions/create/${bookId}`, { title, content })
  }

  post ({ id, bookId, memberIds }) {
    return $axios.post(`/api/discussions/post/${id}/${bookId}`, { memberIds })
  }

  update ({ id, title, content, bookId, newBookId }) {
    return $axios.put(`/api/discussions/update/${id}/${bookId}`, { title, content, newBookId })
  }

  delete ({ id, bookId }) {
    return $axios.delete(`/api/discussions/delete/${id}/${bookId}`)
  }

  resolve ({ id, bookId }) {
    return $axios.post(`/api/discussions/resolve/${id}/${bookId}`)
  }

  getMessages ({ discussionId, bookId, page, limit = 50 }) {
    return $axios.get(`/api/discussions/messages/${discussionId}/${bookId}?page=${page}&limit=${limit}`)
  }

  addMessage ({ discussionId, bookId, text }) {
    return $axios.post(`/api/discussions/addMessage/${discussionId}/${bookId}`, { text })
  }

  updateMessage ({ id, bookId, text }) {
    return $axios.put(`/api/discussions/updateMessage/${id}/${bookId}`, { text })
  }

  deleteMessage ({ id, bookId }) {
    return $axios.delete(`/api/discussions/deleteMessage/${id}/${bookId}`)
  }

  uploadAttachment ({ discussionId, data }) {
    const headers = {
      'Content-Type': 'multipart/form-data',
      auth: store.state.auth.token
    }

    return $axios.post(`/api/discussions/attachment/${discussionId}`, data, headers)
  }

  deleteAttachments (ids) {
    return $axios.delete('/api/discussions/attachment/', { data: { ids: ids } })
  }

  updateAttachments ({ messageId, ids }) {
    return $axios.put(`/api/discussions/attachment/${messageId}`, { ids: ids })
  }

  // updateMessageStatus ({ discussionId }) {
  //   return $axios.put(`/api/discussions/status/${discussionId}`)
  // }

  getReactions () {
    return $axios.get('/api/discussions/reactions')
  }

  toggleReaction ({ messageId, reactionId, bookId, discussionId }) {
    const query = messageId ? `?messageId=${messageId}` : `?discussionId=${discussionId}`
    return $axios.post(`/api/discussions/reactions/${reactionId}/${bookId}${query}`)
  }

  toggleMember ({ memberId, discussionId, bookId }) {
    return $axios.post(`/api/discussions/mention/${bookId}`, { memberId, discussionId })
  }
}

export const discussionsService = new DiscussionsService()
